import { onDocumentReady } from '../utils/dom';
import { debounce } from '../utils/performance';
import { initVideo } from '../services/video';

const state = {
  elements: {},
  components: [],
};

const cacheState = () => {
  state.elements = {
    items: document.querySelectorAll(".collections__promoBanner[data-href]"),
  };
  const sections = Array.from(document.querySelectorAll('.collections__list'));
  state.components = sections.reduce((acc, curr) => {
    const currentComponent = {
      banners: Array.from(curr.querySelectorAll('.collections__promoBanner')),
    };
    return [...acc, currentComponent];
  }, []);
};

function setVideoBackground() {
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  state.components.forEach((component) => {
    const { banners } = component;
    banners.forEach((banner) => {
      const video = banner.querySelector('video');
      if (!video) return;

      const newSrc = isMobile
        ? video.dataset.srcMobile
        : video.dataset.srcDesktop;
      if (video.src !== newSrc) {
        video.src = newSrc;
        video.load();
        video.play();
      }
    });
  });
}

const redirectItem = (e, item) => {
  if (!e.target.closest('a')) {
    window.location.href = item.getAttribute('data-href');
  }
};

const attachEventListeners = () => {
  state.elements.items.forEach(item => item.addEventListener("click", (e) => redirectItem(e, item)));

  const debouncedSetVideoBackground = debounce(setVideoBackground, 200);
  window.addEventListener('resize', debouncedSetVideoBackground);
};

const init = () => {
  cacheState();
  attachEventListeners();

  setVideoBackground();
  initVideo(state.components);
};

onDocumentReady(init);